import fetchPost, {fetchResPsot} from '@/api/http.js'

import fetchPostFormData from '@/api/http.js'
import axios from 'axios'

let baseURL = process.env.NODE_ENV === 'production' ? "/" : "/api";
const instance = axios.create({
    baseURL: baseURL,
    timeout: 5 * 60 * 1000,
    headers: { 'Content-Type': 'multipart/form-data' }
});

export default {
    state: {
        "hasrequesSensitAdressList": false,
        "sensitiveAdressList": [],
    },
    getters: {
        sensitiveAdressList(state) {
            return state.sensitiveAdressList
        },
        hasrequesSensitAdressList(state) {
            return state.hasrequesSensitAdressList
        }
    },
    mutations: {
        SAVESENSITADRESSLIST(state, data) {
            state.sensitiveAdressList = data
            state.hasrequesSensitAdressList = true
        }
    },
    actions: {
        addAddressApi({ }, data) {
            return fetchPost('/saas/baseInfo/addrInformationCfg/save', data)
        },
        queryAddressApi({ }, data) {
            return fetchPost('/saas/baseInfo/addrInformationCfg/queryPage', data)
        },
        queryCarTypeListApi({ }, data) {
            return fetchPost('/saas/orderCore/listVehicleCfgs', data)
        },
        queryAddrByCoordinateApi({ }, data) {
            return fetchPost('/saas/baseInfo/addrInformationCfg/queryAddressByCoordinate', data)
        },
        queryAddrByKeywordApi({ }, data) {
            return fetchPost('/saas/baseInfo/addrInformationCfg/queryTip', data)
        },
        initPlaceApi({ }, data) {
            return fetchPost('/saas/orderCore/initPlace', data)
        },
        calcDisAndTmApi({ }, data) {
            return fetchPost('/orderApi/saasOrderCoreService/getDistanceAndTm', data)
        },
        calcPriceApi({ }, data) {
            return fetchPost('/saas/orderCore/calcPrice', data)
        },
        getDriverInfoApi({ }, data) {
            return fetchPost('/saas/orderCore/getDriverInfo', data)
        },
        getCarrierInfoApi({ }, data) {
            return fetchPost('/saas/orderCore/getCarrierInfo', data)
        },
        placeOrderApi({ }, data) {
            return fetchPost('/saas/orderCore/placeOrder', data)
        },
        placeOrderResApi({ }, data) {
            return fetchResPsot('/saas/orderCore/placeOrder', data)
        },
        /* 长期订单 */
        planOrderAddApi({ }, data) {
            return fetchPost('/saas/planOrder/add', data)
        },
        getPlanOrderListApi({ }, data) {
            return fetchPost('/saas/planOrder/list', data)
        },
        getPlanOrderListApiLong({ }, data) {
            return fetchPost('/saas/batchOrder/queryPage', data)
        },
        getPlanOrderList_wApi({ }, data) {
            return fetchPost('/saas/planOrder/weekSchedule', data)
        },
        /* 长期货单统计 */
        getPlanOrderStatApi({},data){
            return fetchPost('/saas/batchOrder/queryStat', data)
        },
        /* 临时用车关联订单 */
        relPlanOrderApi({ }, data) {
            return fetchPost('/saas/planOrder/relPlanOrder', data)
        },
        planOrderExportApi({ }, data) {
            return fetchPost('/saas/planOrder/export', data)
        },
        planOrderExportApiLong({ }, data,){
            return fetchPost('/saas/batchOrder/export', data)
        },
        getPlanOrderDetailApi({ }, data) {
            return fetchPost('/saas/planOrder/detail', data)
        },
        getPlanOrderDetailApiLong({ }, data){
            return fetchPost('/saas/batchOrder/queryDetail', data)
        },
        cancelPlanOrderApi({ }, data) {
            return fetchPost('/saas/planOrder/cancel', data)
        },
        cancelPlanOrderApiLong({ }, data) {
            return fetchPost('/saas/batchOrder/cancel', data)
        },
        stoplPlanOrderNewApi({ }, data) {
            return fetchPost('/saas/planOrder/stop', data)
            // return fetchPost('/saas/batchOrder/cancel', data)
        },

        thirdPlaceOrderApi({ }, data) {
            return fetchPost('/saas/orderCore/thirdPlaceOrder', data)
        },
        thirdPlaceOrderResApi({ }, data) {
            return fetchResPsot('/saas/orderCore/thirdPlaceOrder', data)
        },
        getOrderListApi({ }, data) {
            return fetchPost('/saas/orderCore/list', data)
        },
        exportApi({ }, data) {
            return fetchPost('/saas/orderCore/export', data)
        },
        receiptExportApi({ }, data) {
            return fetchPost('/saas/receipt/export', data)
        },
        getOrderDetailApi({ }, data) {
            return fetchPost('/saas/orderCore/detail', data)
        },
        getGoodListInfoApi({},data) {
            return fetchPost('/saas/deliveryAccess/queryOrderDetailGoodsInfo', data)
        },
        cancelOrderApi({ }, data) {
            return fetchPost('/saas/orderCore/cancel', data)
        },
        ensureOrderApi({ }, data) {
            return fetchPost('/saas/orderCore/ensure', data)
        },
        queryReceiptApi({ }, data) {
            return fetchPost('/saas/orderCore/queryReceipt', data)
        },
        queryTrackApi({ }, data) {
            return fetchPost('/saas/orderCore/queryTrack', data)
        },
        uploadToSaveOrderApi({ }, data) {
            return instance.post('/saas/orderCore/uploadToSaveOrder', data)  
        },
        uploadToSaveOrderApiLong({ }, data) {
            return instance.post('/saas/batchOrder/importBatchOrder', data) 
        },
        uploadUsualLineApi({ }, data) {
            return fetchPostFormData('/saas/usualLine/upload', data)
        },
        querylistAllCitysApi({ }, data) {
            return fetchPost('/saas/usualLine/querylistAllCitys', data)
        },
        getUsualLineListApi({ }, data) {
            return fetchPost('/saas/usualLine/queryList', data)
        },
        delUsualLineApi({ }, data) {
            return fetchPost('/saas/usualLine/del', data)
        },
        saveUsualLineApi({ }, data) {
            return fetchPost('/saas/usualLine/save', data)
        },
        getUsualLineByIdApi({ }, data) {
            return fetchPost('/saas/usualLine/getById', data)
        },

        getOrderAlterInfoApi({ }, data) {
            return fetchPost('/saas/orderCore/queryOrder', data)
        },
        getProcessListApi({ }, data) {
            return fetchPost('/saas/orderCore/processList', data)
        },
        updateOrderApi({ }, data) {
            return fetchPost('/saas/orderCore/updateOrder', data)
        },
        getProcessDetailApi({ }, data) {
            return fetchPost('/saas/orderCore/processDetail', data)
        },
        queryBidDetailApi({ }, data) {
            return fetchPost('/saas/orderCore/queryBidDetail', data)
        },
        queryBidDetailApiLong({ }, data) {
            return fetchPost('/saas/batchOrder/queryPrice', data)
        },
        confirmBidApi({ }, data) {
            return fetchPost('/saas/orderCore/confirmBid', data)
        },
        confirmBidApiLong({ }, data) {
            return fetchPost('/saas/batchOrder/confirm', data)
        },
        viewImgApi({ }, data) {
            return fetchPost('/saas/receipt/viewImg', data)
        },

        getWaitHandleOrderListApi({ }, data) {
            return fetchPost('/saas/orderAccess/queryPage', data)
        },
        getWaitHandleOrderByIdApi({ }, data) {
            return fetchPost('/saas/orderAccess/queryOrderAccessInfo', data)
        },
        getStopHandleOrderByIdApi({ }, data) {
            return fetchPost('/orderApi/planOrderCoreService/detailByOrderManageId', data)
        },

        /* 平台账户接口 */
        getItemListApi({ }, data) {
            return fetchPost('/saas/projectAssign/list', data)
        },
        getAssignRecordListApi({ }, data) {
            return fetchPost('/saas/projectAssign/detailList', data)
        },
        assignApi({ }, data) {
            return fetchPost('/saas/projectAssign/assign', data)
        },
        assignInfoApi() {
            return fetchPost('/saas/projectAssign/assignInfo',{})
        },queryBankCards() {
            return fetchPost('/saas/shipperOrderController/queryBankListBill',{})
        },txFromSettle({ }, data) {
            return fetchPost('/saas/shipperOrderController/txFromSettle',data)
        },
        queryNotSignedContractApi({ }, data) {
            return fetchPost('/saas/contract/queryNotSignedContract', data)
        },
        searchProjectOptionApi({ }, data) {
            return fetchPost('/saas/orderCore/querySettleProjectInfo', data)
        },
        getExprecePriceApi({ }, data) {
            return fetchPost('/saas/orderCore/getOrderPrice', data)
        },
        getSensitiveAddr({ commit }, data) {
            return fetchPost('/saas/orderCore/getSensitiveAddr', data).then(res => {
                commit('SAVESENSITADRESSLIST', res)
                return res
            })
        },
        /************* S 定标价审批列表 ************/
        orderBiddingApprovalServiceQueryPageApi({ }, data) {
            return fetchPost('/saas/orderBiddingApprovalService/queryPage', data)
        },
        approvalOrderApi({ }, data) {
            return fetchPost('/saas/orderBiddingApprovalService/approvalOrder', data)
        },
        /************* E 定标价审批列表 ************/


      /************* S 订单审批（一口价找车 指派用车） ************/
      // 列表查询
      orderApprovalQueryPage({}, data) {
        return fetchPost('/saas/orderApproval/queryPage', data)
      },
      // 审批
      orderApprovalApprovalOrder({}, data) {
        return fetchPost('/saas/orderApproval/approvalOrder', data)
      },
      // 取消
      orderApprovalCancel({}, data) {
        return fetchPost('/saas/orderApproval/cancel', data)
      },
      /************* E 订单审批（一口价找车 指派用车） ************/
      isShunXin({}) {
        return fetchPost('/saas/orderCore/isSx')
      },
      // 查询司机信息
      queryDriverInfo({}, data) {
        return fetchPost('/saas/orderCore/queryDriverInfo', data)
      }
    }
}
